import { render } from "./PersonalizedProductDetail.vue?vue&type=template&id=e9a99b0a"
import script from "./PersonalizedProductDetail.vue?vue&type=script&lang=js"
export * from "./PersonalizedProductDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__